import { PerspectiveCamera, OrthographicCamera } from '@react-three/drei';

const CAMERA_FOV = 45;

/**
 * Camera component which is added to the scene
 * Camera is orthographic in case of 2D view and Perspective in case of 3D view
 * 
 * @param {*} param0 
 * @returns 
 */
const Cameras = ({ perspective, position, zoom = 2 }) => {
    const { x, y, z } = position;
    const far = Math.max(position.z, 3000) + 100;
    const autoZoom = Math.pow(zoom, 6) / Math.sqrt(z);
    return perspective
        ? <PerspectiveCamera makeDefault position={[x, y, z]} fov={CAMERA_FOV} near={1} far={far} />
        : <OrthographicCamera makeDefault position={[x, y, z]} zoom={autoZoom} near={1} far={far} />;
};

export default Cameras;